/**
 * @generated SignedSource<<441e8159a93a9882bfce3d6cd9cf76bc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LoginSignup = "FREE_TRIAL" | "NEW_SIGNUP" | "%future added value";
export type LoginCreateAccountInput = {
  clientMutationId?: string | null | undefined;
  login: LoginCreateAccount;
};
export type LoginCreateAccount = {
  email: string;
  encryptedEmail?: string | null | undefined;
  firstName: string;
  lastName: string;
  password: string;
  passwordConfirmation: string;
  signupType?: LoginSignup | null | undefined;
};
export type EmailLoginCreateAccountMutation$variables = {
  input: LoginCreateAccountInput;
};
export type EmailLoginCreateAccountMutation$data = {
  readonly loginCreateAccount: {
    readonly errors: ReadonlyArray<{
      readonly messages: ReadonlyArray<string>;
      readonly path: string;
    }>;
  };
};
export type EmailLoginCreateAccountMutation = {
  response: EmailLoginCreateAccountMutation$data;
  variables: EmailLoginCreateAccountMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "messages",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailLoginCreateAccountMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LoginCreateAccountPayload",
        "kind": "LinkedField",
        "name": "loginCreateAccount",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Error",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "EmailLoginCreateAccountMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LoginCreateAccountPayload",
        "kind": "LinkedField",
        "name": "loginCreateAccount",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Error",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "999973391824f6407d437bd5227145df",
    "id": null,
    "metadata": {},
    "name": "EmailLoginCreateAccountMutation",
    "operationKind": "mutation",
    "text": "mutation EmailLoginCreateAccountMutation(\n  $input: LoginCreateAccountInput!\n) {\n  loginCreateAccount(input: $input) {\n    errors {\n      path\n      messages\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "37109fb265b5f902486fcf3ce313c05e";

export default node;
